import Box from "@material-ui/core/Box"
import Button from "@material-ui/core/Button"
import Card from "@material-ui/core/Card"
import CardContent from "@material-ui/core/CardContent"
import CardHeader from "@material-ui/core/CardHeader"
import Typography from "@material-ui/core/Typography"
import { Link } from "react-router-dom"
import { useUrlWithContext } from "../../../hooks/use-url-with-context"
import { paths } from "../../../paths"
import { MaterialSymbol } from "../hour-reporting-roles/components/MaterialSymbol"
import { useHourReportingRolesSettingsTranslations } from "./use-translations"

const HourReportingRolesSettings = () => {
  const translations = useHourReportingRolesSettingsTranslations()
  const { createPathWithContext } = useUrlWithContext()
  const rolesPath = createPathWithContext(`${paths.orgMembers()}?tab=hour-reporting-roles`, {
    withSubContext: false,
  })

  return (
    <Box mt={3}>
      <Card variant="outlined">
        <CardHeader title={translations.title} />
        <CardContent>
          <Typography color="textSecondary">{translations.description}</Typography>
          <Box mt={2} ml={-1}>
            <Button component={Link} to={rolesPath} color="primary" endIcon={<MaterialSymbol name="arrow_outward" />}>
              {translations.viewRolesLabel}
            </Button>
          </Box>
        </CardContent>
      </Card>
    </Box>
  )
}

export default HourReportingRolesSettings
